const ITEMS = [
  "MAHADINUSA LEMBONGAN",
  "TROPICAL SANCTUARY",
  "SANUR ↔ LEMBONGAN FAST BOATS",
  "FLOWERING POOL GARDEN",
  "ISLAND HOST ON CALL",
  "RESERVE DIRECT",
];

export const Marquee = () => (
  <div className="border-y border-ink/10 bg-sand2 py-4 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0">
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center gap-8 pr-8 text-xs font-mono uppercase tracking-[0.3em] text-ink/40">
              {item}
              <span className="h-1.5 w-1.5 rounded-full bg-gold/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
